<template>
    <div class="k-page-content">
      <el-tabs v-model="activeName" class="box-eltab">
        <el-tab-pane label="自动充值" name="first">
          <div class="k-page-common">
            <div class="k-common-header">
              <div class="k-filter-option k-filter-input">
                <el-input
                  placeholder="请输入代理商id"
                  v-model="searchForm.agent_id"
                  :size="size"
                  clearable
                  @blur="doSearch"
                ></el-input>
              </div>
			  <div class="k-filter-option k-filter-input">
			    <el-input
			      placeholder="请输入备款账户id"
			      v-model="searchForm.from_account_id"
			      :size="size"
			      clearable
			      @blur="doSearch"
			    ></el-input>
			  </div>
			  <div class="k-filter-option k-filter-input">
			    <el-input
			      placeholder="请输入充值账户id"
			      v-model="searchForm.account_id"
			      :size="size"
			      clearable
			      @blur="doSearch"
			    ></el-input>
			  </div>
              <div class="k-filter-option">
                <div class="k-select-area">
                    <label>状态：</label>
                    <el-select
                    v-model="searchForm.status"
                    remote
                    clearable
                    :size="size"
                    reserve-keyword
                    @change="doSearch"
                    placeholder="请选择状态"
                    >
                    <el-option
                        v-for="item in options.status"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                    ></el-option>
                    </el-select>
                </div>
              </div>
              <el-button type="primary" :size="size" @click="handleSearch(1)">搜索</el-button>
              <el-button type="primary" :size="size" @click="reset">重置</el-button>
            </div>
            <div class="k-common-con">
              <div class="k-table-wrapper">
                <div class="k-table-toolbar">
                  <div>
                    <el-button type="primary" :size="size" @click="accountMoney">添加</el-button>
                  </div>
                </div>
                <div class="k-table-con">
                  <el-table :data="tableData.data" border style="width: 100%">
                    <el-table-column prop="id" fixed label="ID" min-width="50" align="center"></el-table-column>
                    <el-table-column prop="agent_id" label="代理商ID" min-width="100"></el-table-column>
					<el-table-column prop="from_account_id" label="备款账户ID" min-width="150"></el-table-column>
					<el-table-column prop="account_id" label="目标账户ID" min-width="150"></el-table-column>
					<el-table-column prop="up_limit" label="上限金额" width="100"></el-table-column>
					<el-table-column prop="dow_limit" label="下限金额" width="100"></el-table-column>
                    <el-table-column prop="line_of_credit" label="日限额" width="100"></el-table-column>
                    <!-- <el-table-column prop="use_cost" label="日限已使用" width="100"></el-table-column> -->
					<el-table-column prop="capital_type_str" label="资金类型" min-width="100"></el-table-column>
					<el-table-column prop="media" label="媒体" min-width="100"></el-table-column>
                    <el-table-column label="状态" min-width="100">
                      <template slot-scope="scope">
                          <el-switch
                            v-model="scope.row.status"
                            :active-value="1"
                            :inactive-value="2"
                            @change="handleStatusChange(scope.row)"
                            :size="size"
                          >
                          </el-switch>
                      </template>
                    </el-table-column>
					<el-table-column prop="user_name" label="添加人" width="100"></el-table-column>
                    <el-table-column prop="create_time" label="创建时间" width="170"></el-table-column>
                    <el-table-column fixed="right" label="操作" min-width="120">
                      <template slot-scope="scope">
						<el-button type="text" :size="size" @click="editItem(scope.row.id)">编辑</el-button>
                        <el-button type="text" :size="size" @click="openLogDialog(scope.row.id,'SUB')">日志详情</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                  <el-pagination
                    background
                    ref="pagination"
                    @current-change="handleCurrentChange"
                    :current-page="tableData.page | number"
                    :page-size="tableData.pagesize | number"
                    layout="total, prev, pager, next, jumper"
                    :total="tableData.total | number"
                  ></el-pagination>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
		<el-tab-pane label="备款账户" name="second">
		  <div class="k-page-common">
		    <div class="k-common-header">
		      <div class="k-filter-option k-filter-input">
		        <el-input
		          placeholder="请输入代理商id"
		          v-model="searchForm.agent_id"
		          :size="size"
		          clearable
		          @blur="doSearch"
		        ></el-input>
		      </div>
		      <div class="k-filter-option k-filter-input">
		        <el-input
		          placeholder="请输入备款账户id"
		          v-model="searchForm.from_account_id"
		          :size="size"
		          clearable
		          @blur="doSearch"
		        ></el-input>
		      </div>
		      <el-button type="primary" :size="size" @click="handleSearch(1)">搜索</el-button>
		      <el-button type="primary" :size="size" @click="reset">重置</el-button>
		    </div>
		    <div class="k-common-con">
		      <div class="k-table-wrapper">
		        <div class="k-table-toolbar">
		          <div>
		            <el-button type="primary" :size="size" @click="addSetAccount">添加</el-button>
		          </div>
		        </div>
		        <div class="k-table-con">
		          <el-table :data="setTableData.data" border style="width: 100%">
		            <el-table-column prop="id" fixed label="ID" min-width="50" align="center"></el-table-column>
		            <el-table-column prop="agent_id" label="代理商ID" min-width="150"></el-table-column>
		            <el-table-column prop="account_id" label="备款账户ID" min-width="150"></el-table-column>
		            <el-table-column prop="capital_type_str" label="资金类型" min-width="100"></el-table-column>
                    <el-table-column prop="up_limit" label="上限金额" min-width="100"></el-table-column>
                    <el-table-column prop="dow_limit" label="下限金额" min-width="100"></el-table-column>
                    <el-table-column prop="line_of_credit" label="日限额" width="100"></el-table-column>
                    <el-table-column prop="media" label="媒体" width="100"></el-table-column>
		            <el-table-column prop="user_name" label="添加人" width="100"></el-table-column>
                    <el-table-column prop="create_time" label="创建时间" width="170"></el-table-column>
                    <el-table-column fixed="right" label="操作" min-width="160">
                      <template slot-scope="scope">
						<el-button :disabled="!($parent.$parent.info.views.user.id == scope.row.uid)" type="text" :size="size" @click="editSetAccount(scope.row.id)">编辑</el-button>
                        <el-button :disabled="!($parent.$parent.info.views.user.id == scope.row.uid)" type="text" :size="size" @click="delSetAccount(scope.row.id)">删除</el-button>
                        <el-button type="text" :size="size" @click="openLogDialog(scope.row.id,'BEIKUAN')">日志详情</el-button>
                      </template>
                    </el-table-column>
		          </el-table>
		          <el-pagination
		            background
		            ref="setPagination"
		            @current-change="handleSetCurrentChange"
		            :current-page="setTableData.page | number"
		            :page-size="setTableData.pagesize | number"
		            layout="total, prev, pager, next, jumper"
		            :total="setTableData.total | number"
		          ></el-pagination>
		        </div>
		      </div>
		    </div>
		  </div>
		</el-tab-pane>
      </el-tabs>
        <!-- 添加充值弹窗 -->
        <el-drawer custom-class="k-drawer" :visible.sync="addFormVisiable" direction="rtl" size="70%" :wrapperClosable="false">
            <el-form
                :model="addForm"
                ref="addForm"
                :size="size"
                label-width="110px"
                label-position="top"
            >
                <div class="drawer-header">
                    <div class="header-title">
                        <span>自动充值</span>
                        <i class="el-icon-close k-drawer-close" @click="clearnForm"></i>
                    </div>
                </div>
                <div class="drawer-content">
                    <el-form-item label="备款账户:" prop="from_account_id" :rules="{ required: true, message: '请选择打款的广告主', trigger: 'change' }">
                        <el-select
                            style="width: 100%"
                            v-model="addForm.from_account_id"
                            filterable
                            remote
                            reserve-keyword
                            :remote-method="getDKAccountSelect"
                            collapse-tags
                            placeholder="可输入备款账户名称或备款账户ID搜索">
                            <el-option
                            v-for="item in options.DKdata"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="目标账户:">
                        <p>
                            <el-input
                            type="textarea"
                            :rows="10"
                            placeholder='批量输入目标账户ID,英文","(逗号)隔开,例:3243432,78686787...'
                            v-model="addForm.to_account_ids">
                            </el-input>
                        </p>
                        <p style="margin-top: 10px;">
                            <el-button :size="size" type="primary" @click="addPSearch">批量生成</el-button>
                        </p>
                    </el-form-item>
                    <el-form-item v-if="addForm.info_arr.length > 0">
                        <div class="form-tip" style="margin-left: 0px;">日限额、周限额、月限额中0为不限额</div>
                        <el-table :data="tableDataWithControl" style="width: 100%" border size="mini" class="plcz">
                            <el-table-column label="目标账户ID" width="90">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.isControl">批量设置</span>
                                    <span v-else>{{ scope.row.to_account_id }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="资金类型" width="90">
                                <template slot-scope="scope">
                                    <span>{{ scope.row.capital_type_str }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="上限金额" min-width="150">
                                <template slot-scope="scope">
                                    <el-input v-if="scope.row.isControl" v-model="totalUpLimit" @input="updateAllUpLimit" :size="size">
                                        <template slot="append">元</template>
                                    </el-input>
                                    <el-form-item v-else :prop="'info_arr.' + (showControlRow ? scope.$index - 1 : scope.$index) + '.up_limit'" :rules="[{ required: true, message: '上限金额不能为空', trigger: 'blur' },{ validator: function(rule, value, callback){ const regex = /^\d+(\.\d{1,2})?$/; if(!regex.test(value)){ callback('金额不合法'); }else{ callback(); } }, trigger: 'blur' }]">
                                        <el-input v-model="scope.row.up_limit" :size="size">
                                            <template slot="append">元</template>
                                        </el-input>
                                    </el-form-item>
                                </template>
                            </el-table-column>
                            <el-table-column label="下限金额" min-width="150">
                                <template slot-scope="scope">
                                    <el-input v-if="scope.row.isControl" v-model="totalDownLimit" @input="updateAllDownLimit" :size="size">
                                        <template slot="append">元</template>
                                    </el-input>
                                    <el-form-item v-else :prop="'info_arr.' + (showControlRow ? scope.$index - 1 : scope.$index) + '.dow_limit'" :rules="[{ required: true, message: '下限金额不能为空', trigger: 'blur' },{ validator: function(rule, value, callback){ const regex = /^\d+(\.\d{1,2})?$/; if(!regex.test(value)){ callback('金额不合法'); }else{ callback(); } }, trigger: 'blur' }]">
                                        <el-input v-model="scope.row.dow_limit" :size="size">
                                            <template slot="append">元</template>
                                        </el-input>
                                    </el-form-item>
                                </template>
                            </el-table-column>
                            <el-table-column label="日限额" min-width="150">
                                <template slot-scope="scope">
                                    <el-input v-if="scope.row.isControl" v-model="totalDayLimit" @input="updateAllDayLimit" placeholder="输入日限额" :size="size" :value="totalDayLimit || '0'">
                                        <template slot="append">元</template>
                                    </el-input>
                                    <el-form-item v-else :prop="'info_arr.' + (showControlRow ? scope.$index - 1 : scope.$index) + '.line_of_credit'" :rules="[{ required: true, message: '日限额不能为空', trigger: 'blur' },{ validator: function(rule, value, callback){ const regex = /^\d+(\.\d{1,2})?$/; if(!regex.test(value)){ callback('金额不合法'); }else{ callback(); } }, trigger: 'blur' }]">
                                        <el-input v-model="scope.row.line_of_credit" :size="size">
                                            <template slot="append">元</template>
                                        </el-input>
                                    </el-form-item>
                                </template>
                            </el-table-column>
                            <!-- <el-table-column label="周限额" min-width="150">
                                <template slot-scope="scope">
                                    <el-input v-if="scope.row.isControl" v-model="totalWeekLimit" @input="updateAllWeekLimit" placeholder="输入周限额" :size="size" :value="totalWeekLimit || '0'">
                                        <template slot="append">元</template>
                                    </el-input>
                                    <el-form-item v-else :prop="'info_arr.' + (showControlRow ? scope.$index - 1 : scope.$index) + '.week_line_of_credit'" :rules="[{ required: true, message: '周限额不能为空', trigger: 'blur' },{ validator: function(rule, value, callback){ const regex = /^\d+(\.\d{1,2})?$/; if(!regex.test(value)){ callback('金额不合法'); }else{ callback(); } }, trigger: 'blur' }]">
                                        <el-input v-model="scope.row.week_line_of_credit" :size="size">
                                            <template slot="append">元</template>
                                        </el-input>
                                    </el-form-item>
                                </template>
                            </el-table-column>
                            <el-table-column label="月限额" min-width="150">
                                <template slot-scope="scope">
                                    <el-input v-if="scope.row.isControl" v-model="totalMonthLimit" @input="updateAllMonthLimit" placeholder="输入月限额" :size="size" :value="totalMonthLimit || '0'">
                                        <template slot="append">元</template>
                                    </el-input>
                                    <el-form-item v-else :prop="'info_arr.' + (showControlRow ? scope.$index - 1 : scope.$index) + '.month_line_of_credit'" :rules="[{ required: true, message: '月限额不能为空', trigger: 'blur' },{ validator: function(rule, value, callback){ const regex = /^\d+(\.\d{1,2})?$/; if(!regex.test(value)){ callback('金额不合法'); }else{ callback(); } }, trigger: 'blur' }]">
                                        <el-input v-model="scope.row.month_line_of_credit" :size="size">
                                            <template slot="append">元</template>
                                        </el-input>
                                    </el-form-item>
                                </template>
                            </el-table-column> -->
                            <el-table-column label="操作" width="80">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.isControl"></span>
                                    <el-button v-else type="danger" :size="size" @click="deleteItem(showControlRow ? scope.$index - 1 : scope.$index)">删除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-form-item>
                </div>
                <div class="drawer-footer">
                    <el-button type="primary" :size="size" @click="addMoneyTrans('addForm')" :loading="loading">{{ loading ? '提交中 ...' : '确 定' }}</el-button>
                    <el-button :size="size" @click="clearnForm">取消</el-button>
                </div>
                </el-form>

        </el-drawer>
        <!-- 编辑窗口 -->
        <el-drawer custom-class="k-drawer" :visible.sync="editFormVisiable" direction="rtl" size="40%" :wrapperClosable="false">
            <el-form
                :model="editForm"
                ref="editForm"
                :size="size"
                label-width="110px"
                label-position="top"
            >
                <div class="drawer-header">
                    <div class="header-title">
                        <span>编辑自动充值</span>
                        <i class="el-icon-close k-drawer-close" @click="clearEditForm"></i>
                    </div>
                </div>
                <div class="drawer-content">
                    <el-form-item label="备款账户:" prop="from_account_id">
                        <el-select
                            style="width: 100%"
                            v-model="editForm.from_account_id"
                            disabled
                            :size="size">
                            <el-option
                            v-for="item in options.DKdata"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="目标账户:" prop="account_id">
                        <el-input v-model="editForm.account_id" :size="size" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="资金类型:" prop="capital_type_str">
                        <el-input v-model="editForm.capital_type_str" :size="size" disabled style="width: 200px;"></el-input>
                    </el-form-item>
                    <el-form-item label="上限金额:" prop="up_limit" :rules="[{ required: true, message: '上限金额不能为空', trigger: 'blur' },{ validator: validateNumber, trigger: 'blur' }]">
                        <el-input v-model="editForm.up_limit" :size="size" style="width: 200px;">
                            <template slot="append">元</template>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="下限金额:" prop="dow_limit" :rules="[{ required: true, message: '下限金额不能为空', trigger: 'blur' },{ validator: validateDownLimit, trigger: 'blur' }]">
                        <el-input v-model="editForm.dow_limit" :size="size" style="width: 200px;">
                            <template slot="append">元</template>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="日限额:" prop="line_of_credit" :rules="[{ required: true, message: '日限额不能为空', trigger: 'blur' },{ validator: function(rule, value, callback){ const regex = /^\d+(\.\d{1,2})?$/; if(!regex.test(value)){ callback('金额不合法'); }else{ callback(); } }, trigger: 'blur' }]">
                        <el-input v-model="editForm.line_of_credit" :size="size" style="width: 200px;">
                            <template slot="append">元</template>
                        </el-input>
                        <div class="form-tip">0为不限额</div>
                    </el-form-item>
                    <!-- <el-form-item label="周限额:" prop="week_line_of_credit" :rules="[{ required: true, message: '周限额不能为空', trigger: 'blur' },{ validator: function(rule, value, callback){ const regex = /^\d+(\.\d{1,2})?$/; if(!regex.test(value)){ callback('金额不合法'); }else{ callback(); } }, trigger: 'blur' }]">
                        <el-input v-model="editForm.week_line_of_credit" :size="size" style="width: 200px;">
                            <template slot="append">元</template>
                        </el-input>
                        <div class="form-tip">0为不限额</div>
                    </el-form-item>
                    <el-form-item label="月限额:" prop="month_line_of_credit" :rules="[{ required: true, message: '月限额不能为空', trigger: 'blur' },{ validator: function(rule, value, callback){ const regex = /^\d+(\.\d{1,2})?$/; if(!regex.test(value)){ callback('金额不合法'); }else{ callback(); } }, trigger: 'blur' }]">
                        <el-input v-model="editForm.month_line_of_credit" :size="size" style="width: 200px;">
                            <template slot="append">元</template>
                        </el-input>
                        <div class="form-tip">0为不限额</div>
                    </el-form-item> -->
                </div>
                <div class="drawer-footer">
                    <el-button type="primary" :size="size" @click="updateMoneyTrans('editForm')" :loading="loading">{{ loading ? '提交中 ...' : '确 定' }}</el-button>
                    <el-button :size="size" @click="clearEditForm">取消</el-button>
                </div>
                </el-form>

        </el-drawer>
        <!-- 交易日志 -->
        <el-dialog title="交易日志" :visible.sync="dialogLogVisible" width="80%" :wrapperClosable="false">
            <el-table
                border
                max-height="400"
                :data="logTableData.data"
                :row-class-name="tableRowClassName"
                style="width: 100%">
                <el-table-column prop="id" label="序号" width="50"></el-table-column>
                <el-table-column
                prop="media"
                label="媒体"
                width="100">
                </el-table-column>
                <el-table-column
                prop="agent_id"
                label="代理商ID"
                min-width="150">
                </el-table-column>
                <el-table-column
                prop="from_account_id"
                label="转出方ID"
                min-width="170">
                </el-table-column>
                <el-table-column
                prop="to_account_id"
                label="转入方ID"
                min-width="170">
                </el-table-column>
                <el-table-column
                prop="capital_type_str"
                label="资金类型"
                width="80">
                </el-table-column>
                <el-table-column
                prop="amount"
                label="转账金额(元)"
                width="120">
                </el-table-column>
                <el-table-column
                prop="trade_status_str"
                label="转账状态"
                width="80">
                </el-table-column>
                <el-table-column
                prop="trade_no"
                label="交易码"
                width="220">
                </el-table-column>
                <el-table-column
                prop="message"
                label="交易信息"
                width="100">
                <template slot-scope="scope">
                    <el-popover
                        title="交易信息"
                        width="400"
                        trigger="click"
                        :content="scope.row.message">
                        <el-link type="primary" slot="reference" style="font-size: 12px;" v-if="scope.row.message">查看详情</el-link>
                        <span v-else>无</span>
                    </el-popover>
                </template>
                </el-table-column>
                <el-table-column
                prop="create_time"
                label="转账时间"
                width="180">
                </el-table-column>
            </el-table>
            <el-pagination
                background
                @current-change="handleLogCurrentChange"
                :current-page="logTableData.page | number"
                :page-size="logTableData.pagesize | number"
                layout="total, prev, pager, next, jumper"
                :total="logTableData.total | number"
                style="margin-top: 20px; text-align: right"
            ></el-pagination>
        </el-dialog>
        <!-- 添加备款账户弹窗 -->
        <el-drawer custom-class="k-drawer" :visible.sync="addSetFormVisiable" direction="rtl" size="40%" :wrapperClosable="false">
            <el-form
                :model="addSetForm"
                ref="addSetForm"
                :size="size"
                label-width="110px"
                label-position="top"
            >
                <div class="drawer-header">
                    <div class="header-title">
                        <span>添加备款账户</span>
                        <i class="el-icon-close k-drawer-close" @click="clearSetForm"></i>
                    </div>
                </div>
                <div class="drawer-content">
                    <el-form-item label="代理商ID:" prop="agent_id" :rules="{ required: true, message: '请选择代理商', trigger: 'change' }">
                        <el-select
                            style="width: 100%"
                            v-model="addSetForm.agent_id"
                            placeholder="请选择代理商"
                            @change="handleAgentChange">
                            <el-option
                            v-for="item in agentOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="备款账户ID:" prop="account_id" :rules="{ required: true, message: '请输入备款账户ID', trigger: 'blur' }">
                        <el-input v-model="addSetForm.account_id" :size="size" placeholder="请输入备款账户ID"></el-input>
                    </el-form-item>
                    <el-form-item label="资金类型:" prop="capital_type" :rules="{ required: true, message: '请选择资金类型', trigger: 'change' }">
                        <el-select
                            style="width: 200px;"
                            v-model="addSetForm.capital_type"
                            placeholder="请选择资金类型">
                            <el-option
                            v-for="item in capitalTypeOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="上限金额:" prop="up_limit" :rules="{ required: true, message: '请输入上限金额', trigger: 'blur', validator: validateNumber }">
                        <el-input v-model="addSetForm.up_limit" :size="size" placeholder="请输入上限金额" style="width: 200px;">
                            <template slot="append">元</template>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="下限金额:" prop="dow_limit" :rules="[{ required: true, message: '下限金额不能为空', trigger: 'blur' },{ validator: validateSetDownLimit, trigger: 'blur' }]">
                        <el-input v-model="addSetForm.dow_limit" :size="size" placeholder="请输入下限金额" style="width: 200px;">
                            <template slot="append">元</template>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="日限额:" prop="line_of_credit" :rules="{ required: true, message: '请输入日限额', trigger: 'blur', validator: validateNumber }">
                        <el-input v-model="addSetForm.line_of_credit" :size="size" placeholder="请输入日限额" style="width: 200px;">
                            <template slot="append">元</template>
                        </el-input>
                        <div class="form-tip">0为不限额</div>
                    </el-form-item>
                    <!-- <el-form-item label="周限额:" prop="week_line_of_credit" :rules="{ required: true, message: '请输入周限额', trigger: 'blur', validator: validateNumber }">
                        <el-input v-model="addSetForm.week_line_of_credit" :size="size" placeholder="请输入周限额" style="width: 200px;">
                            <template slot="append">元</template>
                        </el-input>
                        <div class="form-tip">0为不限额</div>
                    </el-form-item>
                    <el-form-item label="月限额:" prop="month_line_of_credit" :rules="{ required: true, message: '请输入月限额', trigger: 'blur', validator: validateNumber }">
                        <el-input v-model="addSetForm.month_line_of_credit" :size="size" placeholder="请输入月限额" style="width: 200px;">
                            <template slot="append">元</template>
                        </el-input>
                        <div class="form-tip">0为不限额</div>
                    </el-form-item> -->
                </div>
                <div class="drawer-footer">
                    <el-button type="primary" :size="size" @click="addSetAccountSubmit('addSetForm')" :loading="loading">{{ loading ? '提交中 ...' : '确 定' }}</el-button>
                    <el-button :size="size" @click="clearSetForm">取消</el-button>
                </div>
                </el-form>

        </el-drawer>
        <!-- 编辑备款账户弹窗 -->
        <el-drawer custom-class="k-drawer" :visible.sync="editSetFormVisiable" direction="rtl" size="40%" :wrapperClosable="false">
            <el-form
                :model="editSetForm"
                ref="editSetForm"
                :size="size"
                label-width="110px"
                label-position="top"
            >
                <div class="drawer-header">
                    <div class="header-title">
                        <span>编辑备款账户</span>
                        <i class="el-icon-close k-drawer-close" @click="clearEditSetForm"></i>
                    </div>
                </div>
                <div class="drawer-content">
                    <el-form-item label="代理商ID:" prop="agent_id" :rules="{ required: true, message: '请选择代理商', trigger: 'change' }">
                        <el-select
                            style="width: 100%"
                            v-model="editSetForm.agent_id"
                            placeholder="请选择代理商"
                            disabled
                            @change="handleEditAgentChange">
                            <el-option
                            v-for="item in agentOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="备款账户ID:" prop="account_id" :rules="{ required: true, message: '请输入备款账户ID', trigger: 'blur' }">
                        <el-input v-model="editSetForm.account_id" :size="size" placeholder="请输入备款账户ID" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="资金类型:" prop="capital_type" :rules="{ required: true, message: '请选择资金类型', trigger: 'change' }">
                        <el-select
                            style="width: 200px;"
                            v-model="editSetForm.capital_type"
                            placeholder="请选择资金类型"
                            disabled>
                            <el-option
                            v-for="item in capitalTypeOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="上限金额:" prop="up_limit" :rules="{ required: true, message: '请输入上限金额', trigger: 'blur', validator: validateNumber }">
                        <el-input v-model="editSetForm.up_limit" :size="size" placeholder="请输入上限金额" style="width: 200px;">
                            <template slot="append">元</template>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="下限金额:" prop="dow_limit" :rules="[{ required: true, message: '下限金额不能为空', trigger: 'blur' },{ validator: validateEditSetDownLimit, trigger: 'blur' }]">
                        <el-input v-model="editSetForm.dow_limit" :size="size" placeholder="请输入下限金额" style="width: 200px;">
                            <template slot="append">元</template>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="日限额:" prop="line_of_credit" :rules="{ required: true, message: '请输入日限额', trigger: 'blur', validator: validateNumber }">
                        <el-input v-model="editSetForm.line_of_credit" :size="size" placeholder="请输入日限额" style="width: 200px;">
                            <template slot="append">元</template>
                        </el-input>
                        <div class="form-tip">0为不限额</div>
                    </el-form-item>
                    <!-- <el-form-item label="周限额:" prop="week_line_of_credit" :rules="{ required: true, message: '请输入周限额', trigger: 'blur', validator: validateNumber }">
                        <el-input v-model="editSetForm.week_line_of_credit" :size="size" placeholder="请输入周限额" style="width: 200px;">
                            <template slot="append">元</template>
                        </el-input>
                        <div class="form-tip">0为不限额</div>
                    </el-form-item>
                    <el-form-item label="月限额:" prop="month_line_of_credit" :rules="{ required: true, message: '请输入月限额', trigger: 'blur', validator: validateNumber }">
                        <el-input v-model="editSetForm.month_line_of_credit" :size="size" placeholder="请输入月限额" style="width: 200px;">
                            <template slot="append">元</template>
                        </el-input>
                        <div class="form-tip">0为不限额</div>
                    </el-form-item> -->
                </div>
                <div class="drawer-footer">
                    <el-button type="primary" :size="size" @click="updateSetAccountSubmit('editSetForm')" :loading="loading">{{ loading ? '提交中 ...' : '确 定' }}</el-button>
                    <el-button :size="size" @click="clearEditSetForm">取消</el-button>
                </div>
                </el-form>

        </el-drawer>
        
    </div>
  </template>
  <style>
    .plcz {
        margin-top: 10px;
        .el-form-item--mini.el-form-item, .el-form-item--small.el-form-item{
            margin-bottom: 0;
        }
        &.el-table .el-table__cell{
            padding: 0;
        }
        &.el-table .cell{
            padding: 15px 10px;
        }
    }
    .el-table .warning-row {
        background:rgba(245,108,108,.3);
    }
    .form-tip {
        font-size: 12px;
        color: #F56C6C;
        display: inline-flex;
        margin-left: 10px;
    }
  </style>
<script>
export default {
    data() {
        return {
            sform:{
                account_ids: ''
            },
            size:'mini',
            activeName:'first',
            addFormVisiable:false,
            editFormVisiable:false,
            addSetFormVisiable:false,
            dialogFormVisible:false,
            dialogLogVisible:false,
            dialogSearchVisible:false,
            loading:false,
            logTableData: {
                total: 0,
                pagesize: 15,
                page: 1,
                data: []
            },
            currentLogId: '',
            currentLogType: '',
            addForm:{
                id:'',
                from_account_id:'',
                to_account_ids:'',
                info_arr:[]
            },
            editForm:{
                id:'',
                from_account_id:'',
                account_id:'',
                capital_type_str:'',
                up_limit:'',
                dow_limit:'',
                line_of_credit:'0',
                // week_line_of_credit:'0',
                // month_line_of_credit:'0'
            },
            addSetForm:{
                agent_id:'',
                account_id:'',
                capital_type:'',
                line_of_credit:'0',
                // week_line_of_credit:'0',
                // month_line_of_credit:'0',
                up_limit:'',
                dow_limit:''
            },
            editSetForm:{
                id:'',
                agent_id:'',
                account_id:'',
                capital_type:'',
                media:'',
                line_of_credit:'0',
                // week_line_of_credit:'0',
                // month_line_of_credit:'0',
                up_limit:'',
                dow_limit:''
            },
            editSetFormVisiable:false,
            agentOptions:[],
            capitalTypeOptions:[],
            totalUpLimit: '',
            totalDownLimit: '',
            totalDayLimit: '0',
            totalWeekLimit: '0',
            totalMonthLimit: '0',
            searchForm: {
                agent_id: '',
                from_account_id: '',
				account_id: '',
                status:1
            },
            options:{
                DKdata:[],
                data:[],
                status:[{
                    value:1,
                    label:'开启'
                },{
                    value:2,
                    label:'关闭'  
                },{
                    value:0,
                    label:'全部'  
                }]
            },
            gridData:[],
            tableData: {
                total: 0,
                pagesize: 15,
                page: 1,
                data: []
            },
            setTableData: {
                total: 0,
                pagesize: 15,
                page: 1,
                data: []
            }
        }
    },
    mounted: function(){
        // 使用的是发布广告使用的获取账户接口，默认会加上广告页面的媒体ID,当前页面不需要加，暂时解决方案是先去掉mediaID
        localStorage.setItem('mediaId', '')
        this.handleSearch()
    },
    computed: {
        tableDataWithControl() {
            if (this.addForm.info_arr.length === 0) return []
            // 只有一行表格时，不需要显示控制行
            if (this.addForm.info_arr.length === 1) {
                return this.addForm.info_arr
            }
            // 创建控制行
            const controlRow = {
                isControl: true,
                capital_type_str: this.addForm.info_arr[0].capital_type_str
            }
            // 组合控制行和数据行
            return [controlRow, ...this.addForm.info_arr]
        },
        showControlRow() {
            return this.addForm.info_arr.length > 1
        }
    },
    watch: {
        activeName(newVal, oldVal) {
            // 切换tab时清空搜索项
            this.searchForm = {
                agent_id: '',
                from_account_id: '',
                account_id: '',
                status:1
            }
            // 切换到备款账户选项卡时，请求备款账户列表
            if (newVal === 'second') {
                this.handleSetSearch()
            }else{
                this.handleSearch()
            }
        }
    },
    methods: {
        tableRowClassName({row, rowIndex}) {
            console.log(row.trade_status)
            if (row.trade_status == 2) {
                return 'warning-row';
            } else if (row.trade_status == 1) {
                return 'success-row';
            }
            return '';
        },
        doSearch: function(event) {
            if (this.activeName === 'first') {
                this.handleSearch()
            } else if (this.activeName === 'second') {
                this.handleSetSearch()
            }
        },
        reset: function() {
            this.searchForm = {
                agent_id: '',
                from_account_id: '',
                account_id: '',
                status:1
            }
            this.handleSearch(page)
        },
        handleCurrentChange: function(page) {
            this.handleSearch(page)
        },
        handleSearch(page, prop, order){
            if (this.activeName === 'first') {
                this.loading = true
                var param = {}
                param['page'] = page ? page : 1
                param['prop'] = prop ? prop : 'id'
                param['order'] = order ? order : 'desc'
                // 传入自动充值页面的搜索参数
                if (this.searchForm.agent_id) {
                    param['agent_id'] = this.searchForm.agent_id
                }
                if (this.searchForm.from_account_id) {
                    param['from_account_id'] = this.searchForm.from_account_id
                }
                if (this.searchForm.account_id) {
                    param['account_id'] = this.searchForm.account_id
                }
                param['status'] = this.searchForm.status
                this.$api.get('money/finance/autolist', param).then(res => {
                    if (res.code === 0) {
                        this.tableData = res.data
                    } else {
                        var message = '查询自动充值列表失败！'
                        if (res.msg) {
                            message = res.msg
                        }
                        this.$message({
                            showClose: true,
                            message: message,
                            type: 'error'
                        })
                    }
                    this.loading = false
                })
            } else if (this.activeName === 'second') {
                this.handleSetSearch(page, prop, order)
            }
        },
        openLogDialog(id,type, page = 1){
            // 保存当前日志的id和type
            this.currentLogId = id
            this.currentLogType = type
            this.$api.get('money/finance/autolog', {id:id,type:type, page: page, pagesize: this.logTableData.pagesize}).then(res => {
                if (res.code === 0) {
                    this.logTableData = res.data
                    this.dialogLogVisible = true
                } else {
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                   })
                }
            })
        },
        accountMoney(){
            this.getDKAccountSelect()
            this.addFormVisiable = true
        },
        addPSearch(){
            if (!this.addForm.to_account_ids || this.addForm.to_account_ids.trim() === '') {
                this.$message.error('请填写目标账户ID')
                return
            }
            // 验证格式：只能为数字，以英文逗号隔开
            const regex = /^\d+(,\d+)*$/
            if (!regex.test(this.addForm.to_account_ids)) {
                this.$message.error('目标账户ID格式错误，只能为数字，以英文逗号隔开')
                return
            }
            if (!this.addForm.from_account_id) {
                this.$message.error('请选择备款账户')
                return
            }
            // 获取选择的备款账户信息
            const selectedAccount = this.options.DKdata.find(item => item.value == this.addForm.from_account_id)
            if (!selectedAccount) {
                this.$message.error('未找到选择的备款账户信息')
                return
            }
            // 分割目标账户ID
            const toAccountIds = this.addForm.to_account_ids.split(',').map(id => id.trim()).filter(id => id)
            if (toAccountIds.length === 0) {
                this.$message.error('请填写有效的目标账户ID')
                return
            }
            // 获取默认值（使用已添加的第一行数据）
            let defaultUpLimit = ''
            let defaultDownLimit = ''
            if (this.addForm.info_arr.length > 0) {
                defaultUpLimit = this.addForm.info_arr[0].up_limit
                defaultDownLimit = this.addForm.info_arr[0].dow_limit
            }
            // 生成目标账户明细
            const newItems = toAccountIds.map(accountId => {
                return {
                    to_account_id: accountId,
                    capital_type_str: selectedAccount.capital_type_str,
                    capital_type: selectedAccount.capital_type,
                    up_limit: defaultUpLimit,
                    dow_limit: defaultDownLimit,
                    line_of_credit: '0',
                    // week_line_of_credit: '0',
                    // month_line_of_credit: '0'
                }
            })
            // 追加到现有列表
            this.addForm.info_arr = [...this.addForm.info_arr, ...newItems]
            // 延迟清空目标账户文本
            setTimeout(() => {
                this.addForm.to_account_ids = ''
            }, 100)
        },
        updateAllUpLimit() {
            this.addForm.info_arr.forEach(item => {
                item.up_limit = this.totalUpLimit
            })
        },
        updateAllDownLimit() {
            this.addForm.info_arr.forEach(item => {
                item.dow_limit = this.totalDownLimit
            })
        },
        updateAllDayLimit() {
            this.addForm.info_arr.forEach(item => {
                item.line_of_credit = this.totalDayLimit
            })
        },
        updateAllWeekLimit() {
            this.addForm.info_arr.forEach(item => {
                item.week_line_of_credit = this.totalWeekLimit
            })
        },
        updateAllMonthLimit() {
            this.addForm.info_arr.forEach(item => {
                item.month_line_of_credit = this.totalMonthLimit
            })
        },
        deleteItem(index) {
            this.addForm.info_arr.splice(index, 1)
        },
        editItem(id) {
            this.loading = true
            this.$api.get('money/finance/getauto', {id: id}).then(res => {
                if (res.code === 0) {
                    const data = res.data
                    // 填充编辑表单数据
                    this.editForm = {
                        id: data.id,
                        from_account_id: data.from_account_id,
                        account_id: data.account_id,
                        capital_type_str: data.capital_type_str || '',
                        up_limit: data.up_limit,
                        dow_limit: data.dow_limit,
                        line_of_credit: data.line_of_credit || '0',
                        // week_line_of_credit: data.week_line_of_credit || '0',
                        // month_line_of_credit: data.month_line_of_credit || '0'
                    }
                    // 打开编辑窗口
                    this.editFormVisiable = true
                } else {
                    this.$message({
                        showClose: true,
                        message: res.msg || '获取编辑详情失败',
                        type: 'error'
                    })
                }
                this.loading = false
            })
        },
        clearnForm(){
            this.addForm = {
                id:'',
                from_account_id:'',
                to_account_ids:'',
                info_arr:[]
            }
            this.totalUpLimit = ''
            this.totalDownLimit = ''
            this.totalDayLimit = '0'
            this.totalWeekLimit = '0'
            this.totalMonthLimit = '0'
            // 清除表单验证状态
            if (this.$refs.addForm) {
                this.$refs.addForm.resetFields()
            }
            this.addFormVisiable = false
        },
        clearEditForm(){
            this.editForm = {
                id:'',
                from_account_id:'',
                account_id:'',
                capital_type_str:'',
                up_limit:'',
                dow_limit:'',
                line_of_credit:'0',
                // week_line_of_credit:'0',
                // month_line_of_credit:'0'
            }
            // 清除表单验证状态
            if (this.$refs.editForm) {
                this.$refs.editForm.resetFields()
            }
            this.editFormVisiable = false
        },
        updateMoneyTrans(formName){
            this.loading = true
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.$api.post('money/finance/settoaccount', this.editForm).then(res => {
                        if (res.code === 0) {
                            this.$message({
                                showClose: true,
                                message: '编辑成功',
                                type: 'success'
                            })
                            this.handleSearch(1)
                        } else {
                            this.$message({
                                showClose: true,
                                message: res.msg,
                                type: 'error'
                            })
                        }
                        this.clearEditForm()
                    })
                }
                this.loading = false
            })
        },
        addMoneyTrans(formName){
            this.loading = true
            if(this.addForm.info_arr.length === 0){
                this.$message({
                    showClose: true,
                    message: '请添加目标账户',
                    type: 'error'
                })
                this.loading = false
                return false
            }
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    // 验证每一行的下限金额是否不超过和等于上限金额
                    let isValid = true
                    for (let i = 0; i < this.addForm.info_arr.length; i++) {
                        const item = this.addForm.info_arr[i]
                        if (parseFloat(item.dow_limit) >= parseFloat(item.up_limit)) {
                            this.$message.error(`第${i + 1}行：下限金额不得超过和等于上限金额`)
                            isValid = false
                            break
                        }
                    }
                    if (isValid) {
                        this.$api.post('money/finance/settoaccount', this.addForm).then(res => {
                            if (res.code === 0) {
                                this.$message({
                                    showClose: true,
                                    message: '自动充值添加成功',
                                    type: 'success'
                                })
                                this.handleSearch(1)
                            } else {
                                this.$message({
                                    showClose: true,
                                    message: res.msg,
                                    type: 'error'
                                })
                            }
                            this.clearnForm()
                        })
                    } else {
                        this.loading = false
                    }
                }
                this.loading = false
            })
        },
        changeAccount(values){
            // 数据表中已经存在的
            var list = []
            values.forEach((item,index)=>{
                list.push({transfer_type:2, account_id:item, cost:'0'})
            })
            this.$set(this.addForm,'info_arr',list)
        },
        getDKAccountSelect:function(query){
            var query_name = ''
            if(query){
                query_name = query
            }
            this.$api.get('money/finance/toselect', {query:query_name}, res => {
                if (res.code == '0') {
                    this.$set(this.options,'DKdata',res.data)
                } else {
                    this.$message.error(res.msg)
                }
            })
        },
        handleStatusChange(row) {
            this.$api.post('money/finance/edauto', {
                id: row.id
            }).then(res => {
                if (res.code === 0) {
                    this.$message({
                        showClose: true,
                        message: '状态更新成功',
                        type: 'success'
                    })
                } else {
                    // 恢复原状态
                    row.status = row.status === '1' ? '2' : '1'
                    this.$message({
                        showClose: true,
                        message: res.msg || '状态更新失败',
                        type: 'error'
                    })
                }
            })
        },
        handleSetSearch(page, prop, order){
            this.loading = true
            var param = {}
            param['page'] = page ? page : 1
            param['prop'] = prop ? prop : 'id'
            param['order'] = order ? order : 'desc'
			if (this.searchForm.agent_id) {
			    param['agent_id'] = this.searchForm.agent_id
			}
			if (this.searchForm.from_account_id) {
			    param['from_account_id'] = this.searchForm.from_account_id
			}
            this.$api.get('money/finance/setlist', param).then(res => {
                if (res.code === 0) {
                    this.setTableData = res.data
                } else {
                    var message = '查询备款账户列表失败！'
                    if (res.msg) {
                        message = res.msg
                    }
                    this.$message({
                        showClose: true,
                        message: message,
                        type: 'error'
                    })
                }
                this.loading = false
            })
        },
        handleSetCurrentChange: function(page) {
            this.handleSetSearch(page)
        },
        handleLogCurrentChange: function(page) {
            // 重新调用openLogDialog方法，传入当前页码
            // 注意：这里需要保存当前打开日志的id和type
            // 由于当前代码中没有保存这些值，我们需要修改openLogDialog方法来保存它们
            // 暂时先添加一个简单的实现，后续可能需要优化
            this.openLogDialog(this.currentLogId, this.currentLogType, page)
        },
        handleSetStatusChange(row) {
            this.$api.post('money/finance/updatesetstatus', {
                id: row.id,
                status: row.status
            }).then(res => {
                if (res.code === 0) {
                    this.$message({
                        showClose: true,
                        message: '状态更新成功',
                        type: 'success'
                    })
                } else {
                    // 恢复原状态
                    row.status = row.status === '1' ? '2' : '1'
                    this.$message({
                        showClose: true,
                        message: res.msg || '状态更新失败',
                        type: 'error'
                    })
                }
            })
        },
        addSetAccount() {
            // 获取代理商列表
            this.$api.get('money/finance/setmedia').then(res => {
                if (res.code === 0) {
                    this.agentOptions = res.data
                } else {
                    this.$message({
                        showClose: true,
                        message: res.msg || '获取代理商列表失败',
                        type: 'error'
                    })
                }
            })
            // 清空表单
            this.clearSetForm()
            // 打开添加备款账户抽屉
            this.addSetFormVisiable = true
        },
        handleAgentChange(value) {
            // 获取选择的代理商信息
            const selectedAgent = this.agentOptions.find(item => String(item.value) === String(value))
            if (selectedAgent) {
                // 设置媒体字段
                this.addSetForm.media = selectedAgent.media
                // 根据代理商的media获取资金类型列表
                this.$api.get('money/finance/capitaltype', {media: selectedAgent.media}).then(res => {
                    if (res.code === 0) {
                        this.capitalTypeOptions = res.data
                        // 清空资金类型选择
                        this.addSetForm.capital_type = ''
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.msg || '获取资金类型列表失败',
                            type: 'error'
                        })
                    }
                })
            }
        },
        validateNumber(rule, value, callback) {
            const regex = /^\d+(\.\d{1,2})?$/
            if (!regex.test(value)) {
                callback('金额不合法')
            } else {
                callback()
            }
        },
        validateDownLimit(rule, value, callback) {
            const regex = /^\d+(\.\d{1,2})?$/
            if (!regex.test(value)) {
                callback('金额不合法')
            } else if (this.editForm.up_limit && parseFloat(value) >= parseFloat(this.editForm.up_limit)) {
                callback('下限金额不得超过和等于上限金额')
            } else {
                callback()
            }
        },
        validateSetDownLimit(rule, value, callback) {
            const regex = /^\d+(\.\d{1,2})?$/
            if (!regex.test(value)) {
                callback('金额不合法')
            } else if (this.addSetForm.up_limit && parseFloat(value) >= parseFloat(this.addSetForm.up_limit)) {
                callback('下限金额不得超过和等于上限金额')
            } else {
                callback()
            }
        },
        validateEditSetDownLimit(rule, value, callback) {
            const regex = /^\d+(\.\d{1,2})?$/
            if (!regex.test(value)) {
                callback('金额不合法')
            } else if (this.editSetForm.up_limit && parseFloat(value) >= parseFloat(this.editSetForm.up_limit)) {
                callback('下限金额不得超过和等于上限金额')
            } else {
                callback()
            }
        },
        validateToAccountIds(rule, value, callback) {
            console.log(value)
            if (!value || value.trim() === '') {
                callback('请输入目标账户ID')
                return
            }
            // 验证格式：只能为数字，以英文逗号隔开
            const regex = /^\d+(,\d+)*$/
            if (!regex.test(value)) {
                callback('目标账户ID格式错误，只能为数字，以英文逗号隔开')
            } else {
                callback()
            }
        },
        addSetAccountSubmit(formName) {
            this.loading = true
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.$api.post('money/finance/setfrom', this.addSetForm).then(res => {
                        if (res.code === 0) {
                            this.$message({
                                showClose: true,
                                message: '添加备款账户成功',
                                type: 'success'
                            })
                            this.handleSetSearch(1)
                        } else {
                            this.$message({
                                showClose: true,
                                message: res.msg || '添加备款账户失败',
                                type: 'error'
                            })
                        }
                        this.clearSetForm()
                    })
                }
                this.loading = false
            })
        },
        clearSetForm() {
            this.addSetForm = {
                agent_id:'',
                account_id:'',
                capital_type:'',
                line_of_credit:'0',
                // week_line_of_credit:'0',
                // month_line_of_credit:'0',
                up_limit:'',
                dow_limit:''
            }
            // 清除表单验证状态
            if (this.$refs.addSetForm) {
                this.$refs.addSetForm.resetFields()
            }
            this.addSetFormVisiable = false
        },
        editSetAccount(id) {
            this.loading = true
            // 先获取代理商列表
            this.$api.get('money/finance/setmedia').then(agentRes => {
                if (agentRes.code === 0) {
                    this.agentOptions = agentRes.data
                    // 再获取备款账户详情
                    this.$api.get('money/finance/getaccount', {id: id}).then(res => {
                        if (res.code === 0) {
                            const data = res.data
                            // 确保agent_id类型正确
                            const agentId = String(data.agent_id)
                            // 填充编辑表单数据
                            this.editSetForm = {
                                id: data.id,
                                agent_id: agentId,
                                account_id: data.account_id,
                                capital_type: data.capital_type,
                                media: data.media || '',
                                line_of_credit: data.line_of_credit || '0',
                                // week_line_of_credit: data.week_line_of_credit || '0',
                                // month_line_of_credit: data.month_line_of_credit || '0',
                                up_limit: data.up_limit,
                                dow_limit: data.dow_limit
                            }
                            // 获取选择的代理商信息
                            const selectedAgent = this.agentOptions.find(item => String(item.value) === agentId)
                            if (selectedAgent) {
                                // 根据代理商的media获取资金类型列表
                                this.$api.get('money/finance/capitaltype', {media: selectedAgent.media}).then(res => {
                                    if (res.code === 0) {
                                        this.capitalTypeOptions = res.data
                                        // 确保资金类型ID类型正确
                                        if (data.capital_type) {
                                            this.editSetForm.capital_type = String(data.capital_type)
                                        }
                                        // 打开编辑弹窗
                                        this.editSetFormVisiable = true
                                        this.loading = false
                                    } else {
                                        this.$message({
                                            showClose: true,
                                            message: res.msg || '获取资金类型列表失败',
                                            type: 'error'
                                        })
                                        this.loading = false
                                    }
                                })
                            } else {
                                // 即使没有找到代理商，也打开弹窗
                                this.editSetFormVisiable = true
                                this.loading = false
                            }
                        } else {
                            this.$message({
                                showClose: true,
                                message: res.msg || '获取备款账户详情失败',
                                type: 'error'
                            })
                            this.loading = false
                        }
                    })
                } else {
                    this.$message({
                        showClose: true,
                        message: agentRes.msg || '获取代理商列表失败',
                        type: 'error'
                    })
                    this.loading = false
                }
            })
        },
        handleEditAgentChange(value) {
            // 获取选择的代理商信息
            const selectedAgent = this.agentOptions.find(item => String(item.value) === String(value))
            if (selectedAgent) {
                // 设置媒体字段
                this.editSetForm.media = selectedAgent.media
                // 根据代理商的media获取资金类型列表
                this.$api.get('money/finance/capitaltype', {media: selectedAgent.media}).then(res => {
                    if (res.code === 0) {
                        this.capitalTypeOptions = res.data
                        // 清空资金类型选择
                        this.editSetForm.capital_type = ''
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.msg || '获取资金类型列表失败',
                            type: 'error'
                        })
                    }
                })
            }
        },
        updateSetAccountSubmit(formName) {
            this.loading = true
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.$api.post('money/finance/setfrom', this.editSetForm).then(res => {
                        if (res.code === 0) {
                            this.$message({
                                showClose: true,
                                message: '编辑备款账户成功',
                                type: 'success'
                            })
                            this.handleSetSearch(1)
                        } else {
                            this.$message({
                                showClose: true,
                                message: res.msg || '编辑备款账户失败',
                                type: 'error'
                            })
                        }
                        this.clearEditSetForm()
                    })
                }
                this.loading = false
            })
        },
        clearEditSetForm() {
            this.editSetForm = {
                id:'',
                agent_id:'',
                account_id:'',
                capital_type:'',
                media:'',
                line_of_credit:'0',
                // week_line_of_credit:'0',
                // month_line_of_credit:'0',
                up_limit:'',
                dow_limit:''
            }
            // 清除表单验证状态
            if (this.$refs.editSetForm) {
                this.$refs.editSetForm.resetFields()
            }
            this.editSetFormVisiable = false
        },
        delSetAccount(id) {
            this.$confirm('确认删除该备款账户吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$api.post('money/finance/delset', {id: id}).then(res => {
                    if (res.code === 0) {
                        this.setTableData.data.forEach(
                            function(item, index) {
                            if (item.id == id) {
                                this.$delete(this.setTableData.data, index)
                            }
                            }.bind(this)
                        )
                        this.$message({
                            showClose: true,
                            message: '删除备款账户成功',
                            type: 'success'
                        })
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.msg || '删除备款账户失败',
                            type: 'error'
                        })
                    }
                })
            })
        }
    }
   
}
</script>